import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { isArray, map } from 'lodash';

interface Props {
    title: string;
    subtitle: string | string[];
    id?: string;
}

const InfoTwoLinesBlock = ({ subtitle, title }: Props) => {
    return (
        <Box
            sx={{
                display: 'block',
                gap: 0,
            }}
        >
            <Typography
                component='div'
                sx={{
                    fontSize: 14,
                    m: 0,
                    mb: 0.5,
                }}
            >
                <b>{title}</b>
            </Typography>

            {isArray(subtitle) ? (
                <Box>
                    {map(subtitle, (item, index) => (
                        <Typography
                            key={`${item}_${index}`}
                            component='div'
                            sx={{
                                fontSize: 14,
                                m: 0,
                            }}
                        >
                            {item}
                        </Typography>
                    ))}
                </Box>
            ) : (
                <Typography
                    component='div'
                    sx={{
                        fontSize: 14,
                        m: 0,
                    }}
                >
                    {subtitle ?? '---'}
                </Typography>
            )}
        </Box>
    );
};

export default InfoTwoLinesBlock;
